<template>
  <div
    id="prinrLabel"
    page="A4">
    <div class="page">
      <div class="printPlate--tag-box-large printPlate--custom__heigth1">
        <div class="printPlate--tag-box-large_inner-group-sender">
          <div class="printPlate--sender-box_large">
            <div class="printPlate--sender-head">
              ผู้ส่ง
              <span class="tel">Tel. {{ brand.phone1 }}</span>
            </div>
            <div class="printPlate--sender-body">
              <div class="printPlate--sender-body_address">
                {{ brand.address }}
              </div>
              <div class="printPlate--sender-body_post">
                <div class="printPlate--sender-body_post_left">
                  รหัสไปรษณีย์
                </div>
                <div class="printPlate--sender-body_post_right">
                  {{ brand.zipcode }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="printPlate--tag-box-large_inner-group">
          <div class="printPlate--receiver-box_large">
            <div class="printPlate--receiver-head">
              <div class="printPlate--receiver-head_left">
                ผู้รับ
              </div>
              <div class="printPlate--receiver-head_right">
                Tel. {{ customer.tel }}
              </div>
            </div>
            <div class="printPlate--receiver-body">
              <div class="printPlate--receiver-body_address">
                <div>
                  <p class="name">
                    {{ customer.name }}
                  </p>
                  <div class="address">
                    <p>
                      {{ customer.address }}
                      <span>ตำบล/แขวง {{ customer.subDistrict }} อำเภอ/เขต {{ customer.district }} {{ customer.province }} </span>
                      <span>{{ customer.postcode }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="printPlate--receiver-body_post">
                <div class="printPlate--receiver-body_post_left">
                  รหัสไปรษณีย์
                </div>
                <div class="printPlate--receiver-body_post_right">
                  {{ customer.postcode }}
                </div>
              </div>
            </div>
          </div>
          <div class="printPlate--bar-code-box">
            <div class="printPlate--bar-code">
              <barcode
                class="printPlate--bar-code-code"
                :value="billDetail.id"
                :font-size="11"
                :width="1.5"
                :height="35" />
              <div class="printPlate--bar-code-detail">
                <p>
                  บิลเลขที่ : {{ billDetail.id }}
                </p>
                <p>
                  ประเภทจัดส่ง : {{ billDetail.shippingType }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="printPlate--receipt">
        <div class="printPlate--receipt_left">
          <div
            class="printPlate--receipt-store">
            <img
              class="printPlate--receipt-store-photo"
              src="https://sellsuki-picture.s3-ap-southeast-1.amazonaws.com/20180525114759GtGLsJoKlF_create">
            <p class="printPlate--receipt-store-name">
              {{ brand.name }}
            </p>
            <p class="printPlate--receipt-store-address">
              {{ brand.address }} {{ brand.zipcode }}
            </p>
          </div>
          <p class="printPlate--receipt-sender-title">
            ชื่อ-ที่อยู่จัดส่งลูกค้า
          </p>
          <div class="printPlate--receipt-customer-address">
            <div>
              <div>
                <p class="name">
                  {{ customer.name }}
                </p>
                <div class="address">
                  <p>
                    {{ customer.address }}
                    <span>ตำบล/แขวง {{ customer.subDistrict }} อำเภอ/เขต {{ customer.district }} {{ customer.province }} </span>
                    <span>{{ customer.postcode }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="printPlate--receipt-contact">
            <p>
              Tel. : {{ customer.tel }}
            </p>
          </div>
          <p class="printPlate--receipt-channel">
            ช่องทางที่สั่งซื้อ
          </p>
          <p> Fulfillment by CAMP </p>
        </div>

        <div class="printPlate--receipt_right_large printPlate--custom__heigth1-1">
          <p class="printPlate--receipt-head">
            ใบเสร็จ / ใบส่งของ
          </p>
          <div class="printPlate--receipt-detail">
            <div class="printPlate--receipt-detail_left">
              <p class="printPlate--receipt-detail_head printPlate--title">
                บิลเลขที่
              </p>
              <p class="printPlate--receipt-detail_content">
                {{ billDetail.id }}
              </p>
              <div>
                <p class="printPlate--receipt-detail_head printPlate--title">
                  วันที่สั่งซื้อ
                </p>
                <p class="printPlate--receipt-detail_content">
                  <span>{{ this.$dayjs(billDetail.createTime).locale('th').format('D/MM/YYYY เวลา HH:mm') }}</span>
                </p>
              </div>
              <p class="printPlate--receipt-detail_head printPlate--title">
                สินค้าทั้งหมด
              </p>
              <p class="printPlate--receipt-detail_content">
                {{ items.length }} รายการ
              </p>
            </div>
            <div class="printPlate--receipt-detail_right">
              <p class="printPlate--receipt-detail_head printPlate--title">
                สถานะ
              </p>
              <p class="printPlate--receipt-detail_content">
                จ่ายแล้ว
              </p>
            </div>
          </div>

          <div class="printPlate--receipt-thead printPlate--title">
            <div class="printPlate--receipt-thead_count">
              ลำดับ
            </div>
            <div class="printPlate--receipt-thead_col_list">
              รายการสินค้า
            </div>
            <div class="printPlate--receipt-thead_col_amount">
              จำนวน
            </div>
            <div class="printPlate--receipt-thead_col_price">
              ราคา
            </div>
          </div>

          <div
            v-for="(item,index) in items"
            :key="index"
            class="printPlate--receipt-tbody">
            <div class="printPlate--receipt-tbody_count">
              {{ index+1 }}
            </div>
            <div class="printPlate--receipt-tbody_col_list">
              <p>
                {{ item.productName }} ({{ item.concatOptions }})
              </p>
              <p>
                {{ item.code }}
              </p>
            </div>
            <div class="printPlate--receipt-tbody_col_amount">
              1
            </div>
            <div class="printPlate--receipt-tbody_col_price">
              {{ item.price | showFullPriceFormat() }}
            </div>
            <div
              v-if="index+1 === items.length"
              class="page-break page-break_last">
            </div>
          </div>
        </div>
      </div>

      <div class="printPlate--receipt_right_bottom">
        <div class="printPlate--receipt-summary summary-background">
          <div class="printPlate--receipt-summary_left">
            <p class="printPlate--title">
              ค่าจัดส่ง
            </p>
            <p class="printPlate--title">
              ส่วนลด
            </p>
            <p class="printPlate--title">
              ยอดรวมสุทธิ
            </p>
          </div>
          <div class="printPlate--receipt-summary_right">
            <p>
              {{ billDetail.shippingPrice | showFullPriceFormat() }}
            </p>
            <p>
              {{ billDetail.discount | showFullPriceFormat() }}
            </p>
            <p class="printPlate--title">
              {{ billDetail.net | showFullPriceFormat() }}
            </p>
          </div>
        </div>
        <p class="printPlate--note">
          <span class="printPlate--title">ประเภทจัดส่ง :</span> {{ billDetail.shippingType }}
        </p>
        <p class="printPlate--note">
          <span class="printPlate--title">หมายเหตุ :</span> {{ !!billDetail.note ? billDetail.note : '-' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode'
import OrderProvider from '@/resources/OrderProvider'

const orderService = new OrderProvider()

export default {
  components: {
    barcode: VueBarcode
  },
  data () {
    return {
      paramID: this.$route.params.id,
      items: [],
      billDetail: {
        id: '',
        status: '',
        link: '',
        shippingPrice: '',
        shippingType: '',
        discount: '',
        net: '',
        tacking: '',
        brand: '',
        note: '',
        createTime: ''
      },
      customer: {
        name: '',
        tel: '',
        address: '',
        subDistrict: '',
        district: '',
        province: '',
        postcode: '',
        country: ''
      },
      bill: undefined,
      brand: {}
    }
  },
  async mounted () {
    await this.getOrderDetail()
    setTimeout(() => window.print(), 1000)
  },
  methods: {
    async getOrderDetail () {
      this.loading = true
      try {
        const { data } = await orderService.getBillById(this.paramID)
        this.bill = data.bill
        const { bill, brand } = data
        this.items = bill.items
        this.billDetail = {
          id: bill.id,
          status: bill.currentState,
          link: `https://bill.akitahub.com/th/b/${bill.url}`,
          shippingPrice: parseFloat(bill.shipCost),
          discount: parseFloat(bill.discount),
          net: parseFloat(bill.net),
          tacking: bill.shippingRefCode,
          shippingType: bill.cacheShippingType,
          note: bill.note,
          createTime: bill.createTime
        }
        this.customer = {
          name: bill.customerName,
          tel: bill.customerTel,
          address: bill.customerAddress,
          subDistrict: bill.customerSubDistrict,
          district: bill.customerDistrictCity,
          province: bill.customerStateProvince,
          postcode: bill.customerPostcode,
          country: bill.customerCountry
        }
        this.brand = brand
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    }
  }
}
</script>

<style>
#prinrLabel {
  color: #000000de;
  display: block;
  background: #ffffff;
  width: 230mm;
  min-height: 297mm;
  margin: 20px auto 20px;
  padding: 10mm;
  box-shadow: 0 0 0.5cm rgba(0,0,0,.5);
}
#prinrLabel p {
  margin-bottom: 0;
}
div[page=A4] * {
  vertical-align: baseline;
}
@media print {
  @page {
    size: A4;
    margin: 10mm;
  }
  main.v-main {
    background-color: #fff !important;
  }
  nav.v-navigation-drawer {
    display: none;
  }
  header.v-sheet.v-toolbar.v-app-bar.v-app-bar--fixed {
    display: none;
  }
  main.v-main {
    padding-left: 0 !important;
  }
  #prinrLabel {
    width: 210mm;
    box-shadow: none;
    margin: 0;
    padding: 0;
  }
  div.page {
    display: block;
  }
}
div.block, div.page {
  width: 100%;
  display: inline-block;
}
.page-break, .print-sm--signature, div.page {
  page-break-inside: avoid;
}
.printPlate--custom__heigth1 {
  height: 420px!important;
}
.printPlate--tag-box-large, .printPlate--tag-box-large-no {
  border-bottom: dashed 1px #ccc;
  height: 470px;
}
.printPlate--tag-box-large-no_inner-group-sender, .printPlate--tag-box-large_inner-group-sender {
  float: left;
  width: 304px;
  margin-right: 37px;
}
.printPlate--tag-box-large-no_inner-group, .printPlate--tag-box-large_inner-group {
  float: left;
  width: 452px;
}
.printPlate--receiver-box_extra-small,
.printPlate--receiver-box_large,
.printPlate--receiver-box_small,
.printPlate--sender-box_small,
.printPlate--sender-box_large,
.printPlate--blue-box {
  border: 2px solid #a7a7a7;
  border-radius: 4px;
}
.printPlate--sender-box_large {
  float: left;
  width: 100%;
  height: 227px;
  font-size: 18px;
  margin-bottom: 28px;
  margin-right: 37px;
}
.printPlate--sender-body_post {
  height: 30px;
}
.printPlate--sender-box_large .printPlate--sender-head {
  border-bottom: solid 1px #a7a7a7;
  width: 100%;
  height: 45px;
  padding-left: 10px;
  line-height: 45px;
}
.printPlate--sender-box_large .printPlate--sender-head .tel {
  float: right;
  margin-right: 8px;
}
.printPlate--sender-box_large .printPlate--sender-body {
  height: calc(100% - 45px);
}
.printPlate--sender-body {
  width: 100%;
  height: calc(100% - 28px);
  padding: 15px 10px 10px;
  line-height: 1.3em;
}
.printPlate--receiver-box_large {
  float: left;
  width: 100%;
  height: 300px;
  font-size: 23px;
}
.printPlate--receiver-box_large .printPlate--receiver-head_left {
  float: left;
  height: 58px;
  width: 104px;
  border-right: solid 1px #a7a7a7;
  padding-left: 10px;
}
.printPlate--receiver-box_large .printPlate--receiver-head_right {
  float: left;
  height: 58px;
  width: calc(100% - 104px);
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
}
.printPlate--receiver-box_large .printPlate--receiver-head {
  border-bottom: solid 1px #a7a7a7;
  width: 100%;
  height: 58px;
  line-height: 2.5em;
}
.printPlate--receiver-box_large .printPlate--receiver-body {
  width: 100%;
  height: calc(100% - 58px);
  padding: 20px;
}
.printPlate--receiver-box_large .printPlate--receiver-body_address {
  height: calc(100% - 40px);
  line-height: 1.2em;
}
.printPlate--receiver-box_large .printPlate--receiver-body_post {
  height: 40px;
}
.printPlate--receiver-box_large .printPlate--receiver-body_post_left {
  float: left;
  height: 40px;
  line-height: 2.8em;
  vertical-align: bottom;
}
.printPlate--receiver-box_large .printPlate--receiver-body_post_right {
  float: right;
  font-size: 44px;
}
.printPlate--bar-code-box {
  float: left;
  margin-top: 15px;
  margin-bottom: 10px;
}
.printPlate--bar-code-detail {
  float: left;
  height: 100%;
  font-size: 11px;
  line-height: 1.2em;
  padding-left: 5px;
}
.printPlate--receipt {
  margin-top: 5px;
  padding-top: 35px;
  font-size: 11px;
}
.printPlate--receipt_left {
  float: left;
  width: 50%;
  padding-right: 60px;
}
.printPlate--receipt-store {
  margin-bottom: 40px;
}
.printPlate--receipt-store-photo {
  width: 50px;
  height: 50px;
  border: 1px solid #D8D8D8;
  margin-bottom: 5px;
}
.printPlate--receipt-channel, .printPlate--receipt-sender-title, .printPlate--title {
  font-size: 12px;
  font-weight: 700;
}
.printPlate--receipt-customer-address {
  width: 185px;
}
.printPlate--receipt-channel, .printPlate--receipt-contact {
  margin-top: 15px;
}
.printPlate--receipt_right_large {
  float: left;
  width: 50%;
  min-height: 485px;
  padding-bottom: 20px;
}
.printPlate--custom__heigth1-1 {
  min-height: 540px;
}
.printPlate--receipt-head {
  text-align: right;
  font-size: 21px;
  font-weight: 700;
  padding-right: 10px;
}
.printPlate--receipt-detail {
  margin-top: 40px;
  padding-left: 10px;
  padding-right: 10px;
  display: inline-block;
  line-height: 2em;
  width: 100%;
}
.printPlate--receipt-detail_left {
  float: left;
  width: 75%;
}
.printPlate--receipt-detail_head {
  float: left;
  width: 30%;
}
.printPlate--receipt-detail_content {
  float: left;
  width: 70%;
}
.printPlate--receipt-detail_right {
  float: left;
  width: 25%;
  text-align: right;
}
.printPlate--receipt-thead {
  margin-top: 15px;
  padding-left: 10px;
  padding-right: 10px;
  height: 20px;
  border-bottom: 1px solid #979797;
}
.printPlate--receipt-thead_count {
  width: 10%;
  float: left;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
.printPlate--receipt-thead_col_list {
  width: 50%;
  float: left;
  padding-left: 5px;
  padding-right: 5px;
}
.printPlate--receipt-thead_col_amount {
  width: 20%;
  float: left;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
.printPlate--receipt-thead_col_price {
  width: 20%;
  float: right;
  padding-left: 5px;
  padding-right: 0;
  text-align: right;
}
.printPlate--receipt-tbody {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  min-height: 32px;
  line-height: 1.2em;
  display: inline-block;
  width: 100%;
}
.printPlate--receipt-tbody_count {
  width: 10%;
  float: left;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
.printPlate--receipt-tbody_col_list {
  width: 50%;
  float: left;
  padding-left: 5px;
  padding-right: 5px;
}
.printPlate--receipt-tbody_col_amount {
  width: 20%;
  float: left;
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
.printPlate--receipt-tbody_col_price {
  width: 20%;
  float: right;
  padding-left: 5px;
  padding-right: 0;
  text-align: right;
}
.page-break {
  page-break-after: always;
  display: block;
}
.printPlate--receipt_right_bottom {
  display: inline-block;
  margin-left: 50%;
  width: 50%;
  line-height: 2em;
  font-size: 11px;
}
.printPlate--receipt-summary {
  line-height: 1.8em;
  height: 75px;
  padding: 10px;
  background-color: #F5F5F5;
  margin-bottom: 5px;
}
.printPlate--note {
  white-space: pre-wrap;
  word-wrap: break-word;
  padding: 0 10px;
  line-height: 14px;
}
.printPlate--receipt-summary_left {
  float: left;
  width: 75%;
}
.printPlate--receipt-summary_right {
  float: left;
  width: 25%;
  text-align: right;
}
.printPlate--sender-body_post {
  height: 30px;
}
.printPlate--sender-body_address {
  height: calc(100% - 30px);
  word-wrap: break-word;
}
.printPlate--sender-body_post_left {
  float: left;
  height: 30px;
  line-height: 34px;
}
.printPlate--sender-body_post_right {
  float: right;
  font-size: 30px;
}
#prinrLabel svg.vue-barcode-element {
  user-select: none;
  display: block;
}
</style>
